module.exports = __webpack_public_path__ + "static/anchoringbiasex-23c291a03359763339875a0880d43b41.png";